import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import Button from "../../components/Button";

const CustomCheckbox = withStyles({
	root: {
		color: "#326dff",
		"&$checked": {
			color: "#326dff",
		},
	},
	checked: {},
})(Checkbox);

const DeliveryZonesControl = (props) => {
	const { zones, setZones, saveData } = props;
	const classes = useStyles();

	const handleZoneClick = (index) => {
		const updated = [...zones];
		updated[index].isActive = !updated[index].isActive;
		setZones(updated);
	};

	return (
		<div className={classes.wrapper}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={7}>
					<Typography variant="h6" className={classes.title}>
						Контроль зон доставки
					</Typography>
					{zones?.map((zone, index) => (
						<div key={zone.id || index} className={classes.terminalContainer}>
							<CustomCheckbox
								checked={!!zone.isActive}
								onChange={() => handleZoneClick(index)}
							/>
							<div>
								Увімкнути доставку у зоні <b>{zone.name}</b>
							</div>
						</div>
					))}
					<div className={classes.buttonContainer}>
						<Button
							className={classes.button}
							load={false}
							text={"Зберегти"}
							handleClick={saveData}
						/>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

const useStyles = makeStyles(() => ({
	wrapper: {
		padding: "24px 16px 24px 16px",
		background: "#FFF",
		border: "0.5px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: "5px 5px 0px 0px",
	},
	terminalContainer: {
		width: "100%",
		height: "auto",
		display: "flex",
		alignItems: "center",
	},
	title: {
		marginBottom: 10,
		fontSize: 20,
	},
	buttonContainer: {
		margin: 16,
	},
	button: {
		textTransform: "none",
	},
}));

export default DeliveryZonesControl;
